/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierStarterQuizEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_STARTER_QUIZ_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierStarterQuizEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierStarterQuizEnabledSettingParser.decode(input).map(res => new TierStarterQuizEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierStarterQuizEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierStarterQuizEnabledSettingParser.encode(data);
    }
    static schema() {
        return TierStarterQuizEnabledSettingParser.schema();
    }
}
